import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

const { Types, Creators } = createActions({
  setOrigin: ['originText', 'originData'],
  setDestination: ['destinationText', 'destinationData'],
  swapOriginDestination: [],
});

export const INITIAL_STATE = Immutable({
  originText: '',
  originData: null,
  destinationText: '',
  destinationData: null,
});

const setOrigin = (state, { originText, originData }) => state.merge({ originText, originData });
const setDestination = (state, { destinationText, destinationData }) => state.merge({ destinationText, destinationData });
const swapOriginDestination = state => state.merge({
  originText: state.destinationText,
  originData: state.destinationData,
  destinationText: state.originText,
  destinationData: state.originData,
});

export default Creators;
export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_ORIGIN]: setOrigin,
  [Types.SET_DESTINATION]: setDestination,
  [Types.SWAP_ORIGIN_DESTINATION]: swapOriginDestination,
});
